import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import ScaleLoader from "react-spinners/ScaleLoader"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { RootState } from "../../store"
import { loadAllRejectReasons, loadPurchaseRequest } from "../../store/purchaseRequest.store"
import Header from "../Layout/Header"
import PurchaseModal from "./PurchaseModal"
import PurchaseRequestTable from "./PurchaseRequestTable"
import RejectModal from "./RejectModal"
import WalletRequestModal from "./WalletRequestModal"

const PurchaseRequest = () => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()
    const { userInfo } = useAppSelector((state: RootState) => state.auth)
    const { purchaseRequest, rejectReasons, loading } = useAppSelector(
        (state: RootState) => state.purchaseRequest
    )
    const [requestData, setRequestData] = useState({})
    const [totalPriceData, setTotalPriceData] = useState(0)
    const [diffPriceData, setDiffPriceData] = useState(0)
    const [show, setShow] = useState(false)
    const [purchaseShow, setPurchaseShow] = useState(false)
    const [walletRequestShow, setWalletRequestShow] = useState(false)
    useEffect(() => {
        // if (purchaseRequest.length === 0){
        dispatch(loadPurchaseRequest())
        dispatch(loadAllRejectReasons())
        // }
    }, [])
    const viewModalClose = () => {
        setShow(false)
        setPurchaseShow(false)
        setWalletRequestShow(false)
        setTotalPriceData(0)
        setDiffPriceData(0)
        setRequestData({})
    }
    const onRejectRequest = (data: any) => {
        setRequestData(data)
        setShow(true)
    }

    const onPurchaseRequest = (data: any, totalPrice: number) => {
        setRequestData(data)
        setTotalPriceData(totalPrice)
        setPurchaseShow(true)
    }

    const onWalletRequest = (data: any, totalPrice: number) => {
        setRequestData(data)
        var totalDiff = totalPrice - data?.amount
        setTotalPriceData(totalPrice)
        setDiffPriceData(totalDiff)
        setWalletRequestShow(true)
    }

    return (
        <>
            {loading || !userInfo?.accessToken ? (
                <div className="loader row justify-content-center">
                    <ScaleLoader color="#15397F" width={4} height={40} />
                </div>
            ) : (
                <div className="purchase-request-container">
                    <Header
                        title={t("Purchase_Request")}
                        records={
                            purchaseRequest?.filter((request: any) => ![1, 7].includes(request.status_id))
                                ?.length
                        }
                        data={purchaseRequest
                            ?.filter((request: any) => ![1, 7].includes(request.status_id))
                            .map((request: any) => {
                                return { ...request, user: request.User?.user_pin }
                            })}
                        name="Users"
                        buttonId="#usersExportButton">
                        <div className="mx-2">
                            {/* <DateRangePickerCustom setStartDate={setStartDate} setEndDate={setEndDate} /> */}
                        </div>
                    </Header>

                    <div className="row  d-flex">
                        <PurchaseRequestTable
                            purchaseRequest={purchaseRequest?.filter(
                                (request: any) => ![1, 7].includes(request.status_id)
                            )}
                            onRejectRequestClick={onRejectRequest}
                            onPurchaseRequestClick={onPurchaseRequest}
                            onWalletRequestClick={onWalletRequest}
                        />
                        <RejectModal
                            show={show}
                            viewModalClose={viewModalClose}
                            rejectReasons={rejectReasons}
                            modalRow={requestData}
                        />
                        <PurchaseModal
                            show={purchaseShow}
                            viewModalClose={viewModalClose}
                            modalRow={requestData}
                            totalPriceData={totalPriceData}
                        />
                        <WalletRequestModal
                            show={walletRequestShow}
                            viewModalClose={viewModalClose}
                            modalRow={requestData}
                            rejectReasons={rejectReasons}
                            totalPriceData={totalPriceData}
                            diffPriceData={diffPriceData}
                        />
                    </div>
                </div>
            )}
        </>
    )
}

export default PurchaseRequest
